"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolarisTopBar = void 0;
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const nice_modal_react_1 = __importDefault(require("@ebay/nice-modal-react"));
const AccountContext_1 = require("contexts/AccountContext");
const context_1 = require("@/common/context");
const components_1 = require("@/common/components");
const polaris_icons_1 = require("@shopify/polaris-icons");
const useLogout_1 = require("hooks/useLogout");
const react_router_dom_1 = require("react-router-dom");
const polaris_top_bar_styles_1 = require("./polaris-top-bar.styles");
const malomoLogo_svg_1 = __importDefault(require("assets/images/dashboard/malomoLogo.svg"));
const PolarisTopBar = () => {
    const [menuActive, setMenuActive] = (0, react_1.useState)(false);
    const { account } = (0, AccountContext_1.useAccount)();
    const { currentUser } = (0, context_1.useCurrentUser)();
    const [announceKitUser, setAnnounceKitUser] = (0, react_1.useState)(undefined);
    const [firstInitial, setFirstInitial] = (0, react_1.useState)('');
    const handleLogout = (0, useLogout_1.useLogout)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    nice_modal_react_1.default.register('switch-account-modal', components_1.SwitchAccountModal);
    const toggleMenu = (0, react_1.useCallback)(() => setMenuActive((active) => !active), []);
    const handleAccountSwitchMenuLink = (0, react_1.useCallback)(() => {
        nice_modal_react_1.default.show('switch-account-modal');
        toggleMenu();
    }, []);
    const handleSettingsMenuLink = (0, react_1.useCallback)(() => {
        navigate('/settings/profile');
        toggleMenu();
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if (account) {
            setFirstInitial(((_a = account === null || account === void 0 ? void 0 : account.name) === null || _a === void 0 ? void 0 : _a.charAt(0)) || '');
            setAnnounceKitUser({ id: account.id, name: account.name });
        }
    }, [account]);
    const avatar = (react_1.default.createElement(polaris_1.Avatar, { initials: firstInitial ? firstInitial.toUpperCase() : '', name: (account === null || account === void 0 ? void 0 : account.name) || '', size: 'lg' }));
    const userMenu = (react_1.default.createElement(polaris_top_bar_styles_1.StyledMenuTab, { className: 'dropdown-toggle-button', onClick: toggleMenu },
        react_1.default.createElement(polaris_1.InlineStack, { gap: '300' },
            react_1.default.createElement("div", null),
            react_1.default.createElement(polaris_1.BlockStack, null,
                react_1.default.createElement(polaris_1.Text, { as: 'h4', id: 'usermenu-current-account-name', tone: 'text-inverse', variant: 'bodySm' }, (account === null || account === void 0 ? void 0 : account.name) || ''),
                react_1.default.createElement(polaris_1.Text, { as: 'p', id: 'usermenu-current-username', tone: 'text-inverse-secondary', variant: 'bodySm' }, (currentUser === null || currentUser === void 0 ? void 0 : currentUser.name) || '')),
            avatar)));
    const menuItems = [
        {
            items: [
                {
                    accessibilityLabel: 'Switch Account',
                    content: 'Switch Account',
                    icon: polaris_icons_1.PersonIcon,
                    onAction: handleAccountSwitchMenuLink
                },
                {
                    accessibilityLabel: 'Settings',
                    content: 'Settings',
                    icon: polaris_icons_1.SettingsIcon,
                    id: 'settings-link',
                    onAction: handleSettingsMenuLink
                }
            ]
        },
        {
            items: [
                {
                    accessibilityLabel: 'Sign Out',
                    content: 'Sign Out',
                    onAction: () => handleLogout(),
                    role: 'sign-out-button',
                    id: 'sign-out-button'
                }
            ]
        }
    ];
    return (react_1.default.createElement(polaris_top_bar_styles_1.StyledTopBar, null,
        react_1.default.createElement(polaris_1.InlineStack, { align: 'space-between', as: 'div', blockAlign: 'center' },
            react_1.default.createElement("div", null,
                react_1.default.createElement("img", { src: malomoLogo_svg_1.default })),
            react_1.default.createElement(polaris_1.InlineStack, { gap: '600' },
                env.NODE_ENV !== 'test' && (react_1.default.createElement(polaris_1.InlineStack, { gap: '200' },
                    react_1.default.createElement(polaris_top_bar_styles_1.StyledAnnounceKit, { user: announceKitUser, widget: 'https://announcekit.co/widgets/v2/3xftGE' },
                        react_1.default.createElement(polaris_1.Text, { as: 'span', id: 'announcekit-whatsnew', tone: 'text-inverse' }, "What's New?")))),
                react_1.default.createElement(polaris_1.InlineStack, { as: 'div' },
                    react_1.default.createElement(polaris_1.Popover, { activator: userMenu, active: menuActive, autofocusTarget: 'first-node', onClose: toggleMenu, preferredAlignment: 'right' },
                        react_1.default.createElement(polaris_1.ActionList, { actionRole: 'menuitem', sections: menuItems })))))));
};
exports.PolarisTopBar = PolarisTopBar;
